import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeRewardDisciplineListService = (
  params: Types.EmployeeRewardDisciplineListRequest
) =>
  RestAPIClient.call<Types.EmployeeRewardDisciplineListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeRewardDisciplineCreateService = (
  params: Types.EmployeeRewardDisciplineCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeRewardDiscipline>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeRewardDisciplineUpdateService = ({
  id,
  ...rest
}: Types.EmployeeRewardDisciplineUpdateRequest) =>
  RestAPIClient.call<Types.EmployeeRewardDiscipline>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Update.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const employeeRewardDisciplineDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Delete.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });

export const employeeRewardDisciplineDetailService = (id: string) =>
  RestAPIClient.call<Types.EmployeeRewardDiscipline>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });
